<template>
  <div class="agent-detail">
    <AppHeader logoLink="/" />
    <div class="banner centered">
      <div class="banner-inner">
        <div class="avator" :style="`background-image:url('${getAvatarUrl}')`"></div>
        <div class="desc">
          <div class="desc-nickname">{{ info.nickname }}</div>
          <div class="desc-dre">
            <font-icon class="desc-icon" id="idcard" v-if="info.dre"></font-icon>
            <span v-if="info.dre">{{ info.dre }}</span>
            <font-icon class="dot" id="dot" v-if="info.title"></font-icon>
            <span v-if="info.title"> {{ info.title }}</span>
          </div>
          <div class="desc-split"></div>
          <div class="desc-phone" v-if="info.phone && info.phone.length">
            <font-icon class="desc-icon" id="phone"></font-icon>
            <a :href="`tel:${info.phone}`">{{ info.phone }}</a>
          </div>
          <div class="desc-email" v-if="info.email && info.email.length">
            <font-icon class="desc-icon" id="email"></font-icon>
            <a :href="`mailto:${info.email}`">{{ info.email }}</a>
          </div>
          <div class="desc-language" v-if="info.language && info.language.length">
            <font-icon class="desc-icon" id="global"></font-icon>
            {{ getLanguage(info.language) }}
          </div>
          <div class="desc-social">
            <a :href="info.facebook" target="_blank" v-if="info.facebook && info.facebook.length">
              <font-icon id="facebook"></font-icon>
            </a>
            <a :href="info.twitter" target="_blank" v-if="info.twitter && info.twitter.length">
              <font-icon id="twitter"></font-icon>
            </a>
            <a :href="info.instagram" target="_blank" v-if="info.instagram && info.instagram.length">
              <font-icon id="ins"></font-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="main centered">
      <div class="common-title__border-bottom">
        <h1>Meet {{ meetName }}</h1>
      </div>
      <div class="agent-desc" v-if="info.description && info.description.length">
        <div v-html="description"></div>
      </div>
    </div>
    <AppFooter />
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  components: { AppHeader, AppFooter },
  data() {
    return {
      username: this.$route.params.username,
      info: {},
    }
  },
  computed: {
    meetName() {
      const { nickname } = this.info
      if (!nickname) return ''
      const temp = nickname.split(' ')
      return temp[0]
    },
    getAvatarUrl() {
      if (this.info && this.info.avatar && this.info.avatar.url) {
        return this.$processImage(this.info.avatar.url, { resize: 'mid' })
      }
      return ''
    },
    description() {
      let description = this.info.description
      if (description) {
        return description.replace(
          '<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>',
          ''
        )
      }
      return description
    },
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.openFullLoading()

      this.$axios({
          url: '/api/v1/client/estate/getAgentByUsername/' + this.username,
          method: 'get',
        })
        .then(res => {
          this.closeFullLoading()
          this.info = res.user
        })
        .catch(() => {
          this.closeFullLoading()
        })
    },
    openFullLoading() {
      this.loader = this.$loading({
        lock: true,
        text: 'Loading',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
    closeFullLoading() {
      this.loader.close()
    },
    getLanguage(language) {
      let lang = []
      language.forEach(item => {
        lang.push(item.slice(0, 1).toUpperCase() + item.slice(1))
      })
      return lang.join(', ')
    },
  },
}

</script>
<style lang="less" scoped>
.centered {
  width: 960px;
  margin: 0 auto;
}

.banner {
  width: 960px;
  overflow-x: hidden;
  background-color: rgba(244, 244, 244, 0.5);
}

.banner-inner {
  position: relative;
  width: 761px;
  height: 341px;
  margin: 0 auto;
}

.avator {
  position: absolute;
  width: 262px;
  height: 262px;
  bottom: 0;
}

.banner,
.avator {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.desc {
  position: absolute;
  top: 82px;
  left: 418px;
  color: #333;
  width: 100%;
  font-size: 12px;

  .desc-icon {
    margin-right: 12px;
    vertical-align: middle;
  }

  .desc-nickname {
    font-size: 21px;
  }

  .desc-dre {
    font-size: 12px;
    margin-top: 8px;
  }

  .dot {
    vertical-align: middle;
    color: #333;
  }

  .desc-split {
    width: 343px;
    height: 1px;
    background: #333;
    margin: 12px 0;
  }

  .desc-email,
  .desc-language {
    margin-top: 19px;
  }

  .desc-email a,
  .desc-phone a {
    color: #333;
    text-decoration: none;
  }

  .desc-social {
    margin-top: 22px;

    a {
      color: #666;
      text-decoration: none;
      margin-right: 17px;
    }

    a:hover {
      color: #333;
    }
  }
}

.agent-desc {
  margin-top: 34px;

  div {
    line-height: 2;
    margin: 0 0 20px;

    &:last-of-type {
      margin-bottom: 50px;
    }
  }
}

</style>
